import { apiSlice } from 'api/apiSlice'
import { Breadcrumb } from 'shared/types/Breadcrumb'
import { sortBreadcrumbChildren } from 'shared/utils/breadcrumb-utils'

type GetBreadcrumbsParams = {
  slug: string
  locale: string
}

const breadcrumbsApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    breadcrumbs: build.query<Breadcrumb, GetBreadcrumbsParams>({
      query: ({ slug, locale }) => ({
        app: 'sneakers',
        method: 'GET',
        params: { includeChildren: true, locale },
        url: `/web-api/v1/breadcrumbs/${slug}`,
      }),
      transformResponse: (response: Breadcrumb) => {
        return sortBreadcrumbChildren(response)
      },
    }),
  }),
})

export const { useBreadcrumbsQuery } = breadcrumbsApi
